import type { DsstScreen } from '@/pages/dsst/hooks/useGameState';

interface GameHeaderProps {
  screen: DsstScreen;
  onClose: () => void;
}

export default function GameHeader({ screen, onClose }: GameHeaderProps) {
  const isGuide = screen === 'guide';

  return (
    <div
      className={`h-14 flex items-center justify-center px-4 shrink-0 relative z-20 ${
        isGuide ? 'bg-secondary-100' : 'bg-white'
      }`}
    >
      <div className="flex flex-col items-center justify-center">
        <span className="text-base font-bold text-foreground-900 leading-none">
          {isGuide ? '몸풀기 게임' : '연습'}
        </span>
        {isGuide && <div className="mt-2 w-7 h-[3px] bg-primary-500 rounded-full" />}
      </div>

      <button
        onClick={onClose}
        className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full active:bg-secondary-100 transition-colors duration-150"
        aria-label="닫기"
      >
        <i className="ri-close-line text-xl text-foreground-700" />
      </button>
    </div>
  );
}